import Axios from '../../networking/intraceptor';
import Cookies from 'js-cookie';
import {
  pharmacy_chat_users,
  pharmacist_driver_video_calls,
} from '../../networking/urlEndPoints';

export const fetchPharmacistDriverCallDrivers = async () => {
  const { data } = await Axios.get(pharmacy_chat_users, {
    params: {
      assistants_only: 1,
      online_only: 1,
    },
  });
  return data?.data ?? data;
};

export const initiatePharmacistDriverVideoCall = async (driverId, { deferNotify = false } = {}) => {
  const payload = {
    driver_id: driverId,
  };

  if (deferNotify) {
    payload.defer_notify = true;
    payload.suppress_push = true;
  }

  const { data } = await Axios.post(`${pharmacist_driver_video_calls}/initiate`, payload);
  return data?.data ?? data;
};

export const notifyPharmacistDriverVideoCall = async (callId) => {
  const { data } = await Axios.post(`${pharmacist_driver_video_calls}/${callId}/notify-driver`);
  return data?.data ?? data;
};

export const fetchPharmacistDriverVideoCall = async (callId) => {
  const { data } = await Axios.get(`${pharmacist_driver_video_calls}/${callId}`);
  return data?.data ?? data;
};

export const cancelPharmacistDriverVideoCall = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${pharmacist_driver_video_calls}/${callId}/cancel`, payload);
  return data?.data ?? data;
};

export const endPharmacistDriverVideoCall = async (callId) => {
  const { data } = await Axios.post(`${pharmacist_driver_video_calls}/${callId}/end`);
  return data?.data ?? data;
};

const buildApiUrl = (path) => {
  const baseUrl = Axios.defaults.baseURL || process.env.REACT_APP_BASE_URL || '';
  const normalizedPath = String(path || '').replace(/^\/+/, '');

  if (!baseUrl) {
    return `/${normalizedPath}`;
  }

  try {
    return new URL(normalizedPath, baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`).toString();
  } catch (error) {
    return `${String(baseUrl).replace(/\/+$/, '')}/${normalizedPath}`;
  }
};

export const endPharmacistDriverVideoCallOnUnload = (callId) => {
  if (!callId || typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return false;
  }

  const token = Cookies.get('authToken');
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    window.fetch(buildApiUrl(`${pharmacist_driver_video_calls}/${encodeURIComponent(callId)}/end`), {
      method: 'POST',
      headers,
      body: JSON.stringify({ reason: 'page_refresh' }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {});
    return true;
  } catch (error) {
    return false;
  }
};
